// TODO: Fix eslint issues the next time this file is edited.
/* eslint-disable @next/next/link-passhref */
import React from 'react';
import Head from 'next/head';
import NextLink from 'next/link';
import { Block, Flex, Link, Spacer, useTheme } from 'vcc-ui';
import { Footer } from '../components/footer';
import { Header } from '../components/header';

export default function Layout({ children, title, isIndexPage = false }) {
  const theme = useTheme();
  return (
    <Flex extend={{ background: theme.color.background.primary }}>
      <Head>
        <title>{title} - Blog</title>
      </Head>
      <Header activePage="blog" />
      <Block extend={{ height: '73px' }} />
      <Flex
        extend={{
          maxWidth: '760px',
          padding: '20px',
          boxSizing: 'border-box',
          margin: '0 auto',
          flex: 1,
          width: '100%',
        }}
      >
        {!isIndexPage && (
          <Block extend={{ marginTop: '32px' }}>
            <NextLink href="/blog">
              <Link arrow="left" href="/blog">
                All posts
              </Link>
            </NextLink>
          </Block>
        )}
        <Spacer size={3} />
        {children}
      </Flex>
      <Footer />
    </Flex>
  );
}
